import * as ActionTypes from './types.action';

export const submitRefundRequest = (items, accountDetails, axBasketId) => ({
  type: ActionTypes.SEND_REFUND_EMAIL_REQUESTED,
  items,
  accountDetails,
  axBasketId,
});
